import { render, staticRenderFns } from "./LivingSetting.vue?vue&type=template&id=0573de15&scoped=true"
import script from "./LivingSetting.vue?vue&type=script&lang=js"
export * from "./LivingSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0573de15",
  null
  
)

export default component.exports